import { AlloAuthUser } from '@Components/auth/utils';
import { addDays } from '@Core/dateTime/date-time';
import { IConsultationType } from '@Reducers/consultation';
import { IClinicLocationsData } from '@Reducers/schedule';
import { IUserData } from '@Reducers/user';
import { useAppSelector } from '@Redux/hooks';
import { getEndDate } from '@Utils/helper';
import dayjs from 'dayjs';
import { useMemo } from 'react';

const useGetDays = (consultationType: IConsultationType, locationType: IClinicLocationsData, dueDate: string) => {
  const auth: AlloAuthUser = useAppSelector((state) => state.auth.user);
  const userData: IUserData = useAppSelector((state) => state.user.userData);
  const startDate = useMemo(() => {
    //disabling from due date booking
    if (dueDate && !userData?.isActor && false) {
      return dayjs(dueDate).isBefore(dayjs()) ? new Date() : dayjs(dueDate).toDate();
    }
    return new Date();
  }, [dueDate]);
  const endDate = useMemo(() => {
    return addDays(startDate, getEndDate(consultationType?.consultationCode, locationType?.code, auth?.roles));
  }, [consultationType?.consultationCode, locationType?.code]);
  const dateList = [];
  for (let i = startDate; dayjs(i).isBefore(dayjs(addDays(endDate, 1))); i = addDays(i, 1)) {
    dateList.push(dayjs(i).format('YYYY-MM-DD'));
  }
  return {
    dateList,
    startDate,
    endDate,
  };
};

export default useGetDays;
